
































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { RailwayModule } from '@/store/modules/railway'
import { ImageClipper } from "@/utils/imageClipper";
import { ToolbarModule } from "@/store/modules/toolbar"
import { AppModule } from "@/store/modules/app"
import { SingleAssetUsage, AssetFile, AssetsModule } from "@/store/modules/asset";

@Component({
  name: "railway-box",
  components: {
  }
})
export default class RailwayBox extends Vue {
  private railwayImageClipper = ImageClipper.getImageClipper(false, 1);
  private scaleFac = 4.7 / 6.6;
  private railwayImageUrl = "";

  get devotionText() {
    return RailwayModule.dedication.text
  }

  get devotionTextSize() {
    return RailwayModule.dedication.size + "px";
  }

  private evaluateRailwayImage(): {
    usage?: SingleAssetUsage;
    asset?: AssetFile;
  } {
    let asset;
    let usage;
    let assetId = RailwayModule.railwayAssetId;
    if (assetId >= 0) {
      for (let currentAsset of AssetsModule.assets) {
        if (currentAsset.assetId === assetId) {
          asset = currentAsset;
          break;
        }
      }
    }
    if (asset && AppModule.steps[1].usageName) {
      usage = asset.usage[AppModule.steps[1].usageName];
      if (usage) {
        return { usage: usage as SingleAssetUsage, asset };
      }
    }
    return {};
  }

  mounted() {
    let { usage: railwayUsage, asset: railwayAsset } = this.evaluateRailwayImage();
    if (railwayAsset && railwayUsage) {
      this.railwayImageUrl = railwayAsset.url;
      this.railwayImageClipper.initializeUsage(railwayUsage, railwayAsset.rect);
    } else {
      this.railwayImageUrl = "";
    }
  }
}
